var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.loadingState ? _c("loading") : _vm._e(),
      _vm._v(" "),
      !_vm.hideData && !_vm.orderRemoved
        ? _c("div", { staticClass: "container pt-4 mt-5 pb-5" }, [
            _c("div", { staticClass: "row justify-content-center text-left" }, [
              _c("h3", { staticClass: "Regular center h0 widthFull" }, [
                _c("b", [
                  _vm._v("Accetta preventivo N. " + _vm._s(_vm.item.code))
                ])
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "black mt-0 text-center widthFull" }, [
                _vm._v(
                  "\r\n        Completa il form qui sotto.\r\n        I dati inseriti verranno poi utilizzati per creare la pratica del Bonus richiesto.\r\n      "
                )
              ])
            ]),
            _vm._v(" "),
            _c(
              "form",
              {
                staticClass: "pb-5 pt-4  black vaillantCont widthFull",
                attrs: { id: "registration-form" }
              },
              [
                _c("div", { staticClass: "row justify-content-center pb-5 " }, [
                  _c("div", { staticClass: "col-md-12" }, [
                    _vm.item.client_type != "Amministratore di condominio"
                      ? _c("h4", { staticClass: "widthFull center black" }, [
                          _vm._v(
                            "\r\n            Completa i dati del cliente finale ("
                          ),
                          _c("b", [
                            _vm._v(
                              _vm._s(_vm.item.client_name) +
                                " " +
                                _vm._s(_vm.item.client_lastname)
                            )
                          ]),
                          _vm._v(")\r\n          ")
                        ])
                      : _c("h4", { staticClass: "widthFull center black" }, [
                          _vm._v(
                            "\r\n            Completa i dati dell'Amministratore del condominio ("
                          ),
                          _c("b", [
                            _vm._v(
                              _vm._s(_vm.item.client_name) +
                                " " +
                                _vm._s(_vm.item.client_lastname)
                            )
                          ]),
                          _vm._v(")\r\n          ")
                        ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-4 mb-3" }, [
                    _c("div", { staticClass: "group custInput" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.item.client_name,
                            expression: "item.client_name"
                          },
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: { required: true, max: 63, min: 2 },
                            expression: "{required:true, max: 63, min: 2}"
                          }
                        ],
                        staticClass: "form-control",
                        class: {
                          "is-invalid": _vm.errors.has("clientName"),
                          valid: !!_vm.item.client_name
                        },
                        attrs: {
                          type: "text",
                          autocomplete: "randomq",
                          id: "clientName",
                          name: "clientName",
                          "data-vv-as": "Nome"
                        },
                        domProps: { value: _vm.item.client_name },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.item,
                              "client_name",
                              $event.target.value
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "highlight" }),
                      _vm._v(" "),
                      _c("span", { staticClass: "bar" }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "niceInputLabel",
                          attrs: { for: "clientName" }
                        },
                        [_vm._v("Nome *")]
                      ),
                      _vm._v(" "),
                      _vm.errors.has("clientName")
                        ? _c("div", { staticClass: "invalid-feedback" }, [
                            _vm._v(
                              "\r\n              " +
                                _vm._s(_vm.errors.first("clientName")) +
                                "\r\n            "
                            )
                          ])
                        : _vm._e()
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-4 mb-3" }, [
                    _c("div", { staticClass: "group custInput" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.item.client_lastname,
                            expression: "item.client_lastname"
                          },
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: { required: true, max: 63, min: 2 },
                            expression: "{required:true, max: 63, min: 2}"
                          }
                        ],
                        staticClass: "form-control",
                        class: {
                          "is-invalid": _vm.errors.has("clientLastname"),
                          valid: !!_vm.item.client_lastname
                        },
                        attrs: {
                          type: "text",
                          autocomplete: "randomq",
                          id: "clientLastname",
                          name: "clientLastname",
                          "data-vv-as": "Cognome"
                        },
                        domProps: { value: _vm.item.client_lastname },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.item,
                              "client_lastname",
                              $event.target.value
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "highlight" }),
                      _vm._v(" "),
                      _c("span", { staticClass: "bar" }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "niceInputLabel",
                          attrs: { for: "clientLastname" }
                        },
                        [_vm._v("Cognome *")]
                      ),
                      _vm._v(" "),
                      _vm.errors.has("clientLastname")
                        ? _c("div", { staticClass: "invalid-feedback" }, [
                            _vm._v(
                              "\r\n              " +
                                _vm._s(_vm.errors.first("clientLastname")) +
                                "\r\n            "
                            )
                          ])
                        : _vm._e()
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-4 mb-3 " }, [
                    _c("div", { staticClass: "group custInput" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.item.client_email,
                            expression: "item.client_email"
                          },
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: {
                              required: true,
                              email: true,
                              temporaryEmail: true,
                              plusIssueEmail: true,
                              max: 56
                            },
                            expression:
                              "{required:true,email: true, temporaryEmail:true, plusIssueEmail: true, max: 56}"
                          }
                        ],
                        ref: "email",
                        staticClass: "form-control",
                        class: {
                          "is-invalid": _vm.errors.has("email"),
                          valid: !!_vm.item.client_email
                        },
                        attrs: {
                          type: "text",
                          id: "email",
                          name: "email",
                          "data-vv-as": "Email"
                        },
                        domProps: { value: _vm.item.client_email },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.item,
                              "client_email",
                              $event.target.value
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "highlight" }),
                      _vm._v(" "),
                      _c("span", { staticClass: "bar" }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "niceInputLabel",
                          attrs: { for: "email" }
                        },
                        [_vm._v("Email* ")]
                      ),
                      _vm._v(" "),
                      _vm.errors.has("email")
                        ? _c("div", { staticClass: "invalid-feedback" }, [
                            _vm._v(
                              "\r\n              " +
                                _vm._s(_vm.errors.first("email")) +
                                "\r\n            "
                            )
                          ])
                        : _vm._e()
                    ])
                  ]),
                  _vm._v(" "),
                  _vm.item.client_type == "Persona fisica" ||
                  _vm.item.client_type == "Amministratore di condominio"
                    ? _c("div", { staticClass: "col-md-4" }, [
                        _c("div", { staticClass: "group custInput" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.codice_fiscale,
                                expression: "codice_fiscale"
                              },
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: {
                                  required: true,
                                  codiceFiscale: true,
                                  max: 16,
                                  min: 16
                                },
                                expression:
                                  "{required: true, codiceFiscale: true, max: 16, min: 16}"
                              }
                            ],
                            staticClass: "form-control",
                            class: {
                              "is-invalid": _vm.errors.has("codice_fiscale"),
                              valid: !!_vm.codice_fiscale
                            },
                            attrs: {
                              type: "text",
                              id: "codice_fiscale",
                              name: "codice_fiscale",
                              "data-vv-as": "Codice Fiscale"
                            },
                            domProps: { value: _vm.codice_fiscale },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.codice_fiscale = $event.target.value
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "highlight" }),
                          _vm._v(" "),
                          _c("span", { staticClass: "bar" }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "niceInputLabel",
                              attrs: { for: "codice_fiscale" }
                            },
                            [_vm._v("Codice Fiscale *")]
                          ),
                          _vm._v(" "),
                          _vm.errors.has("codice_fiscale")
                            ? _c("div", { staticClass: "invalid-feedback" }, [
                                _vm._v(
                                  "\r\n              " +
                                    _vm._s(_vm.errors.first("codice_fiscale")) +
                                    "\r\n            "
                                )
                              ])
                            : _vm._e()
                        ])
                      ])
                    : _vm.item.client_type == "Partita IVA"
                    ? _c("div", { staticClass: "col-md-4" }, [
                        _c("div", { staticClass: "group custInput" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.partita_iva,
                                expression: "partita_iva"
                              },
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: {
                                  required: true,
                                  partitaIva: true,
                                  max: 11,
                                  min: 11
                                },
                                expression:
                                  "{required: true, partitaIva: true, max: 11, min: 11}"
                              }
                            ],
                            staticClass: "form-control",
                            class: {
                              "is-invalid": _vm.errors.has("partita_iva"),
                              valid: !!_vm.partita_iva
                            },
                            attrs: {
                              type: "text",
                              id: "partita_iva",
                              name: "partita_iva",
                              "data-vv-as": "Partita IVA"
                            },
                            domProps: { value: _vm.partita_iva },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.partita_iva = $event.target.value
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "highlight" }),
                          _vm._v(" "),
                          _c("span", { staticClass: "bar" }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "niceInputLabel",
                              attrs: { for: "partita_iva" }
                            },
                            [_vm._v("Partita IVA *")]
                          ),
                          _vm._v(" "),
                          _vm.errors.has("partita_iva")
                            ? _c("div", { staticClass: "invalid-feedback" }, [
                                _vm._v(
                                  "\r\n              " +
                                    _vm._s(_vm.errors.first("partita_iva")) +
                                    "\r\n            "
                                )
                              ])
                            : _vm._e()
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-4 mb-3" }, [
                    _c("div", { staticClass: "group custInput" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.item.client_phone,
                            expression: "item.client_phone"
                          },
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: {
                              required: false,
                              max: 12,
                              min: 8,
                              regex: /^[0,3]+/
                            },
                            expression:
                              "{required: false, max: 12, min: 8, regex: /^[0,3]+/}"
                          }
                        ],
                        staticClass: "form-control",
                        class: {
                          "is-invalid": _vm.errors.has("phone"),
                          valid: !!_vm.item.client_phone
                        },
                        attrs: {
                          type: "text",
                          id: "phone",
                          name: "phone",
                          "data-vv-as": "Telefono"
                        },
                        domProps: { value: _vm.item.client_phone },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.item,
                              "client_phone",
                              $event.target.value
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "highlight" }),
                      _vm._v(" "),
                      _c("span", { staticClass: "bar" }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "niceInputLabel",
                          attrs: { for: "phone" }
                        },
                        [_vm._v("Telefono ")]
                      ),
                      _vm._v(" "),
                      _vm.errors.has("phone")
                        ? _c("div", { staticClass: "invalid-feedback" }, [
                            _vm._v(
                              "\r\n              " +
                                _vm._s(_vm.errors.first("phone")) +
                                "\r\n            "
                            )
                          ])
                        : _vm._e()
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-4 mb-3" }, [
                    _c("div", { staticClass: "group custInput" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.item.client_mobile,
                            expression: "item.client_mobile"
                          },
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: {
                              required: true,
                              max: 12,
                              min: 8,
                              regex: /^[0,3]+/
                            },
                            expression:
                              "{required: true, max: 12, min: 8, regex: /^[0,3]+/}"
                          }
                        ],
                        staticClass: "form-control",
                        class: {
                          "is-invalid": _vm.errors.has("mobile"),
                          valid: !!_vm.item.client_mobile
                        },
                        attrs: {
                          type: "text",
                          id: "mobile",
                          name: "mobile",
                          "data-vv-as": "Cellulare"
                        },
                        domProps: { value: _vm.item.client_mobile },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.item,
                              "client_mobile",
                              $event.target.value
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "highlight" }),
                      _vm._v(" "),
                      _c("span", { staticClass: "bar" }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "niceInputLabel",
                          attrs: { for: "mobile" }
                        },
                        [_vm._v("Cellulare * ")]
                      ),
                      _vm._v(" "),
                      _vm.errors.has("mobile")
                        ? _c("div", { staticClass: "invalid-feedback" }, [
                            _vm._v(
                              "\r\n              " +
                                _vm._s(_vm.errors.first("mobile")) +
                                "\r\n            "
                            )
                          ])
                        : _vm._e()
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-12" }, [
                    _c("h4", { staticClass: "widthFull center black" }, [
                      _vm._v("\r\n            Indirizzo immobile: "),
                      _c("b", [
                        _vm._v(
                          _vm._s(_vm.item.building_address) +
                            " " +
                            _vm._s(_vm.item.building_civic) +
                            " - " +
                            _vm._s(_vm.item.building_zip) +
                            " " +
                            _vm._s(_vm.item.building_city) +
                            " (" +
                            _vm._s(_vm.item.building_province) +
                            ")"
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-6" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-12" }, [
                    _c("h4", { staticClass: "widthFull center black pb-4" }, [
                      _vm._v("\r\n            Indirizzo di residenza "),
                      _vm.item.client_type != "Amministratore di condominio"
                        ? _c("span", [_vm._v("(modifica se necessario)")])
                        : _vm._e()
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-4 mb-3" }, [
                    _c("div", { staticClass: "group custInput" }, [
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.province,
                              expression: "province"
                            },
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: { required: true },
                              expression: "{required:true}"
                            }
                          ],
                          staticClass: "form-control",
                          class: {
                            "is-invalid": _vm.errors.has("province"),
                            valid: !!_vm.province
                          },
                          attrs: {
                            autocomplete: "randomy",
                            id: "province",
                            name: "province",
                            "data-vv-as": "Provincia"
                          },
                          on: {
                            change: function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.province = $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            }
                          }
                        },
                        [
                          _c("option", {
                            attrs: {
                              disabled: "",
                              value: "",
                              selected: "selected"
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "option",
                            { key: 2341253542, domProps: { value: "SE" } },
                            [
                              _vm._v(
                                "\r\n                  STATO ESTERO\r\n                "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _vm._l(_vm.provincies, function(province) {
                            return _c(
                              "option",
                              {
                                key: province.sigla,
                                domProps: { value: province.sigla }
                              },
                              [
                                _vm._v(
                                  "\r\n                  " +
                                    _vm._s(province.sigla) +
                                    " - " +
                                    _vm._s(province.provincia) +
                                    "\r\n                "
                                )
                              ]
                            )
                          })
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c("span", { staticClass: "highlight" }),
                      _vm._v(" "),
                      _c("span", { staticClass: "bar" }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "niceInputLabel",
                          attrs: { for: "province" }
                        },
                        [_vm._v("Provincia *")]
                      ),
                      _vm._v(" "),
                      _vm.provinciesState
                        ? _c(
                            "div",
                            [
                              _c("font-awesome-icon", {
                                staticClass: "loadSpinner",
                                attrs: {
                                  id: "loadProvince",
                                  icon: "spinner",
                                  size: "1x",
                                  pulse: ""
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.errors.has("province")
                        ? _c("div", { staticClass: "invalid-feedback" }, [
                            _vm._v(
                              "\r\n                " +
                                _vm._s(_vm.errors.first("province")) +
                                "\r\n              "
                            )
                          ])
                        : _vm._e()
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-4 mb-3" }, [
                    _c("div", { staticClass: "group custInput" }, [
                      _vm.cityError
                        ? _c("span", { staticClass: "formError" }, [
                            _vm._v("Prima scegli Provincia")
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.province != "SE"
                        ? _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.city,
                                  expression: "city"
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: { required: true },
                                  expression: "{required:true}"
                                }
                              ],
                              staticClass: "form-control",
                              class: {
                                "is-invalid": _vm.errors.has("city"),
                                valid: !!_vm.city
                              },
                              attrs: {
                                autocomplete: "randomu",
                                id: "city",
                                name: "city",
                                "data-vv-as": "Località",
                                disabled: _vm.citiesState
                              },
                              on: {
                                click: _vm.checkProvince,
                                change: function($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function(o) {
                                      return o.selected
                                    })
                                    .map(function(o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.city = $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                }
                              }
                            },
                            [
                              _c("option", {
                                attrs: {
                                  disabled: "",
                                  value: "",
                                  selected: "selected"
                                }
                              }),
                              _vm._v(" "),
                              _vm._l(_vm.cities, function(city) {
                                return _c(
                                  "option",
                                  {
                                    key: city.comune,
                                    domProps: {
                                      value: {
                                        cityistat: city.istat,
                                        city: city.comune
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\r\n                  " +
                                        _vm._s(city.comune) +
                                        "\r\n                "
                                    )
                                  ]
                                )
                              })
                            ],
                            2
                          )
                        : _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.citySE,
                                expression: "citySE"
                              },
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: { required: true },
                                expression: "{required:true}"
                              }
                            ],
                            staticClass: "form-control",
                            class: {
                              "is-invalid": _vm.errors.has("citySE"),
                              valid: !!_vm.citySE
                            },
                            attrs: {
                              autocomplete: "randomu",
                              id: "citySE",
                              name: "citySE",
                              "data-vv-as": "Località",
                              disabled: _vm.citiesState
                            },
                            domProps: { value: _vm.citySE },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.citySE = $event.target.value
                              }
                            }
                          }),
                      _vm._v(" "),
                      _c("span", { staticClass: "highlight" }),
                      _vm._v(" "),
                      _c("span", { staticClass: "bar" }),
                      _vm._v(" "),
                      _vm.province != "SE"
                        ? _c(
                            "label",
                            {
                              staticClass: "niceInputLabel",
                              attrs: { for: "city" }
                            },
                            [_vm._v("Località *")]
                          )
                        : _c(
                            "label",
                            {
                              staticClass: "niceInputLabel",
                              attrs: { for: "city" }
                            },
                            [_vm._v("Località e Paese*")]
                          ),
                      _vm._v(" "),
                      _vm.citiesState
                        ? _c(
                            "div",
                            [
                              _c("font-awesome-icon", {
                                staticClass: "loadSpinner",
                                attrs: {
                                  id: "loadCity",
                                  icon: "spinner",
                                  size: "1x",
                                  pulse: ""
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.errors.has("city")
                        ? _c("div", { staticClass: "invalid-feedback" }, [
                            _vm._v(
                              "\r\n                " +
                                _vm._s(_vm.errors.first("city")) +
                                "\r\n              "
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.errors.has("citySE")
                        ? _c("div", { staticClass: "invalid-feedback" }, [
                            _vm._v(
                              "\r\n                " +
                                _vm._s(_vm.errors.first("citySE")) +
                                "\r\n              "
                            )
                          ])
                        : _vm._e()
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-4 mb-3" }, [
                    _c("div", { staticClass: "group custInput" }, [
                      _vm.zipError
                        ? _c("span", { staticClass: "formError" }, [
                            _vm._v("Prima scegli città")
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.province != "SE"
                        ? _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.zip,
                                  expression: "zip"
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: { required: true },
                                  expression: "{required:true}"
                                }
                              ],
                              staticClass: "form-control",
                              class: {
                                "is-invalid": _vm.errors.has("zip"),
                                valid: !!_vm.zip
                              },
                              attrs: {
                                autocomplete: "randomi",
                                id: "zip",
                                name: "zip",
                                "data-vv-as": "Cap",
                                disabled: _vm.zipsState
                              },
                              on: {
                                click: _vm.checkZip,
                                change: function($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function(o) {
                                      return o.selected
                                    })
                                    .map(function(o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.zip = $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                }
                              }
                            },
                            [
                              _c("option", {
                                attrs: { value: "", disabled: "" },
                                domProps: { selected: true }
                              }),
                              _vm._v(" "),
                              _vm._l(_vm.zips, function(zip) {
                                return _c(
                                  "option",
                                  {
                                    key: zip.cap,
                                    domProps: { value: zip.cap }
                                  },
                                  [
                                    _vm._v(
                                      "\r\n                  " +
                                        _vm._s(zip.cap) +
                                        "\r\n                "
                                    )
                                  ]
                                )
                              })
                            ],
                            2
                          )
                        : _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.capSE,
                                expression: "capSE"
                              },
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: { required: true, min: 5, max: 5 },
                                expression: "{required:true, min:5, max:5}"
                              }
                            ],
                            staticClass: "form-control",
                            class: {
                              "is-invalid": _vm.errors.has("capSE"),
                              valid: !!_vm.capSE
                            },
                            attrs: {
                              autocomplete: "randomi",
                              id: "capSE",
                              name: "capSE",
                              "data-vv-as": "Cap",
                              disabled: _vm.zipsState
                            },
                            domProps: { value: _vm.capSE },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.capSE = $event.target.value
                              }
                            }
                          }),
                      _vm._v(" "),
                      _c("span", { staticClass: "highlight" }),
                      _vm._v(" "),
                      _c("span", { staticClass: "bar" }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "niceInputLabel",
                          attrs: { for: "zip" }
                        },
                        [_vm._v("Cap *")]
                      ),
                      _vm._v(" "),
                      _vm.zipsState
                        ? _c(
                            "div",
                            [
                              _c("font-awesome-icon", {
                                staticClass: "loadSpinner",
                                attrs: {
                                  id: "loadZips",
                                  icon: "spinner",
                                  size: "1x",
                                  pulse: ""
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.errors.has("zip")
                        ? _c("div", { staticClass: "invalid-feedback" }, [
                            _vm._v(
                              "\r\n                " +
                                _vm._s(_vm.errors.first("zip")) +
                                "\r\n              "
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.errors.has("capSE")
                        ? _c("div", { staticClass: "invalid-feedback" }, [
                            _vm._v(
                              "\r\n                " +
                                _vm._s(_vm.errors.first("capSE")) +
                                "\r\n              "
                            )
                          ])
                        : _vm._e()
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-6 mb-3" }, [
                    _c("div", { staticClass: "group custInput" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.address,
                            expression: "address"
                          },
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: { required: true, max: 128, min: 5 },
                            expression: "{required:true, max: 128, min: 5}"
                          }
                        ],
                        staticClass: "form-control",
                        class: {
                          "is-invalid": _vm.errors.has("address"),
                          valid: !!_vm.address
                        },
                        attrs: {
                          type: "text",
                          autocomplete: "randomq",
                          id: "address",
                          name: "address",
                          "data-vv-as": "Indirizzo"
                        },
                        domProps: { value: _vm.address },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.address = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "highlight" }),
                      _vm._v(" "),
                      _c("span", { staticClass: "bar" }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "niceInputLabel",
                          attrs: { for: "address" }
                        },
                        [_vm._v("Indirizzo *")]
                      ),
                      _vm._v(" "),
                      _vm.errors.has("address")
                        ? _c("div", { staticClass: "invalid-feedback" }, [
                            _vm._v(
                              "\r\n              " +
                                _vm._s(_vm.errors.first("address")) +
                                "\r\n            "
                            )
                          ])
                        : _vm._e()
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-6 mb-3" }, [
                    _c("div", { staticClass: "group custInput" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.civic,
                            expression: "civic"
                          },
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: { required: true, max: 15, min: 1 },
                            expression: "{required:true, max: 15, min: 1}"
                          }
                        ],
                        staticClass: "form-control",
                        class: {
                          "is-invalid": _vm.errors.has("civic"),
                          valid: !!_vm.civic
                        },
                        attrs: {
                          type: "text",
                          autocomplete: "randomq",
                          id: "civic",
                          name: "civic",
                          "data-vv-as": "Civico"
                        },
                        domProps: { value: _vm.civic },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.civic = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "highlight" }),
                      _vm._v(" "),
                      _c("span", { staticClass: "bar" }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "niceInputLabel",
                          attrs: { for: "civic" }
                        },
                        [_vm._v("Civico *")]
                      ),
                      _vm._v(" "),
                      _vm.errors.has("civic")
                        ? _c("div", { staticClass: "invalid-feedback" }, [
                            _vm._v(
                              "\r\n              " +
                                _vm._s(_vm.errors.first("civic")) +
                                "\r\n            "
                            )
                          ])
                        : _vm._e()
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-6" }, [
                    _c("div", { staticClass: "group custInput" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.numero_ordine,
                            expression: "numero_ordine"
                          },
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: {
                              required: true,
                              max: 10,
                              min: 3,
                              integer: true,
                              regex: /^[1][2]+/
                            },
                            expression:
                              "{required:true, max: 10, min: 3, integer:true, regex: /^[1][2]+/,}"
                          }
                        ],
                        staticClass: "form-control",
                        class: {
                          "is-invalid": _vm.errors.has("numero_ordine"),
                          valid: !!_vm.numero_ordine
                        },
                        attrs: {
                          type: "text",
                          autocomplete: "randomq",
                          id: "numero_ordine",
                          name: "numero_ordine",
                          "data-vv-as": "Numero d'ordine"
                        },
                        domProps: { value: _vm.numero_ordine },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.numero_ordine = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "highlight" }),
                      _vm._v(" "),
                      _c("span", { staticClass: "bar" }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "niceInputLabel",
                          attrs: { for: "numero_ordine" }
                        },
                        [_vm._v("Numero d'ordine * [ es : 12XXXXXXXX ] ")]
                      ),
                      _vm._v(" "),
                      _vm.errors.has("numero_ordine")
                        ? _c("div", { staticClass: "invalid-feedback" }, [
                            _vm._v(
                              "\r\n              " +
                                _vm._s(_vm.errors.first("numero_ordine")) +
                                "\r\n            "
                            )
                          ])
                        : _vm._e()
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-12" }, [
                    _c("h4", { staticClass: "widthFull center black" }, [
                      _vm._v(
                        "\r\n            Carica il preventivo firmato\r\n          "
                      )
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "center" }, [
                      _vm._v(
                        "Se necessario è possibile selezionare piu di un file"
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "front-image" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: {
                              required: true,
                              size: 10240,
                              ext: ["jpeg", "jpg", "png", "pdf"],
                              mimes: [
                                "image/jpeg",
                                "image/jpg",
                                "image/png",
                                "application/pdf"
                              ]
                            },
                            expression:
                              "{required:true,size: 10240, ext: ['jpeg','jpg','png','pdf'], mimes: ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf']}"
                          }
                        ],
                        ref: "fileInput",
                        staticClass: "fileInput",
                        class: {
                          "is-invalid": _vm.errors.has("invoiceFront"),
                          valid: !!_vm.invoiceFront,
                          helper: !!_vm.invoiceFrontBucket
                        },
                        attrs: {
                          type: "file",
                          multiple: "",
                          name: "invoiceFront",
                          id: "invoiceFront",
                          "data-vv-as": "Preventivo firmato"
                        },
                        on: { change: _vm.uploadFile }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "highlight" }),
                      _vm._v(" "),
                      _c("span", { staticClass: "bar" }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "niceInputLabel labelFileInput",
                          attrs: { for: "invoiceFront" }
                        },
                        [
                          !_vm.invoiceFrontName
                            ? _c(
                                "span",
                                {
                                  staticClass: "smallText center white",
                                  style: {
                                    backgroundImage:
                                      "url(" + _vm.invoiceFrontBucket + ")"
                                  }
                                },
                                [
                                  !_vm.invoiceFrontName
                                    ? _c(
                                        "p",
                                        {
                                          staticClass:
                                            "smallText center white mt-3 mb-0 pb-0"
                                        },
                                        [_vm._v("Scegli il Contratto quadro*")]
                                      )
                                    : _vm._e()
                                ]
                              )
                            : _c("span", {
                                staticClass: "smallText center white",
                                style: {
                                  backgroundImage:
                                    "url(" + _vm.invoiceFrontBucket + ")"
                                }
                              })
                        ]
                      ),
                      _vm._v(" "),
                      _vm.errors.has("invoiceFront")
                        ? _c(
                            "div",
                            {
                              staticClass: "invalid-feedback",
                              staticStyle: { top: "185px" }
                            },
                            [
                              _vm._v(
                                "\r\n              " +
                                  _vm._s(_vm.errors.first("invoiceFront")) +
                                  "\r\n            "
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.uploadFrontPercentage
                        ? _c(
                            "div",
                            {
                              staticClass: "progress mt-5",
                              attrs: { id: "progFront" }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "progress-bar ",
                                  style: {
                                    width: _vm.uploadFrontPercentage + "%"
                                  },
                                  attrs: {
                                    id: "progress-bar-front",
                                    role: "progressbar",
                                    "aria-valuenow": "50",
                                    "aria-valuemin": "0",
                                    "aria-valuemax": "100"
                                  }
                                },
                                [
                                  _vm._v(
                                    "\r\n                " +
                                      _vm._s(_vm.uploadFrontPercentage) +
                                      " %\r\n              "
                                  )
                                ]
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.invoiceFrontName
                        ? _c(
                            "p",
                            {
                              staticClass:
                                "smallText center white mt-3 mb-0 pb-0 fileNameText"
                            },
                            [_vm._v(_vm._s(_vm.invoiceFrontName))]
                          )
                        : _vm._e()
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-12 mt-5 mb-3 center" }, [
                    _vm.invoiceFrontBucket
                      ? _c(
                          "a",
                          {
                            attrs: {
                              href: _vm.invoiceFrontBucket,
                              target: "_blank"
                            }
                          },
                          [
                            _vm.invoiceFrontBucket.substring(
                              _vm.invoiceFrontBucket.lastIndexOf(".") + 1,
                              _vm.invoiceFrontBucket.length
                            ) == "pdf"
                              ? _c(
                                  "a",
                                  {
                                    staticClass: "center widthFull pdfLink",
                                    attrs: {
                                      href: _vm.invoiceFrontBucket,
                                      target: "_blank"
                                    }
                                  },
                                  [_vm._v("APRI  PDF")]
                                )
                              : _vm._e()
                          ]
                        )
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-12 center mt-5 pt-4" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary",
                        attrs: { type: "button" },
                        on: { click: _vm.convertToPractice }
                      },
                      [_vm._v("Procedi")]
                    )
                  ])
                ])
              ]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.hideData && !_vm.orderRemoved
        ? _c("div", { staticClass: "container pt-4 mt-5" }, [
            _c("div", { staticClass: "row justify-content-center text-left" }, [
              _c("h3", { staticClass: "Regular center h0 widthFull" }, [
                _c("b", [
                  _vm._v("Accetta preventivo N. " + _vm._s(_vm.item.code))
                ])
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "black mt-0 text-center widthFull" }, [
                _vm._v(
                  "\r\n        Hai completatto correttamente la pratica.\r\n      "
                )
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.orderRemoved
        ? _c("div", { staticClass: "container pt-5 mt-5 " }, [
            _c(
              "div",
              {
                staticClass: "row justify-content-center text-left vaillantCont"
              },
              [
                _c("h3", { staticClass: "Regular center h0 widthFull" }, [
                  _c("b", [
                    _vm._v("ATTENZIONE! "),
                    _c("br"),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(" Preventivo N. " + _vm._s(_vm.item.code) + " "),
                    _c("br"),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(" è stato eliminato ")
                  ])
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "black mt-0 text-center widthFull" })
              ]
            )
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-83256d60", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-83256d60","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/acceptInvoice/hoval.vue
// module id = null
// module chunks = 